import { API } from "../../Services";

export const utecProjectList = (querry, blank = false) => {
  return (dispatch) => {
    dispatch({
      type: "FETCH_UTEC_PROJECT_LIST",
    });
    if (!blank) {
      API.utecProjectList(querry)
        .then((res) => {
          setTimeout(() => {
            dispatch({
              type: "RECEIVE_UTEC_PROJECT_LIST",
              payload: Array.isArray(res.data)
                ? { totalRecords: 0, data: [] }
                : res.data,
            });
          }, 1000);
        })
        .catch((err) => {
          let data = JSON.parse(JSON.stringify(err.message));
          dispatch({
            type: "ERROR_UTEC_PROJECT_LIST",
            payload: data,
          });
        });
    } else {
      dispatch({
        type: "ERROR_UTEC_PROJECT_LIST_BLANK",
      });
    }
  };
};
